// extracted by mini-css-extract-plugin
export default {"root":"TopbarWishlistLink_root__qdzkJ","icon":"TopbarWishlistLink_icon__8EmxK"};